import { teamDisplayName } from "@/lib/teamNames";

/** VM: ofta starka nationer först (ungefärlig ordning), resten alfabetiskt på visningsnamn. */
const WC_HEADLINE_ORDER = [
  "BR", "AR", "FR", "ES", "EN", "PT", "DE", "NL", "BE", "HR", "IT", "UY", "CO", "MA", "MX", "JP",
];

/**
 * @param {Array<{ code: string, name?: string, shortName?: string }>} teams
 * @param {string} _tournamentKey reserverad för framtida turneringar (endast VM används)
 * @param {"sv"|"en"} lang
 * @returns {Array<{ code: string, label: string, section: "top"|"rest" }>}
 */
export function buildTopscorerTeamOptions(teams, _tournamentKey, lang) {
  if (!teams?.length) return [];
  const list = teams.map((tm) => ({
    code: tm.code,
    label: teamDisplayName(tm.code, tm.name, lang),
    section: "rest",
  }));
  const pri = new Set(WC_HEADLINE_ORDER);
  const headline = [];
  const rest = [];
  for (const row of list) {
    if (pri.has(row.code)) headline.push({ ...row, section: "top" });
    else rest.push(row);
  }
  headline.sort((a, b) => WC_HEADLINE_ORDER.indexOf(a.code) - WC_HEADLINE_ORDER.indexOf(b.code));
  rest.sort((a, b) => a.label.localeCompare(b.label, lang === "sv" ? "sv" : "en"));
  return [...headline, ...rest];
}
